import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
import './ScrollingPage.scss';

interface IProps {
  fade?: boolean;
  className?: string;
  children: any;
}

function useStateRef(initialValue: any) {
  const [value, setValue] = React.useState(initialValue);

  const ref = React.useRef(value);

  React.useEffect(
    () => {
      ref.current = value;
    },
    [value]
  );

  return [value, setValue, ref];
}

export const ScrollingPage: React.FC<IProps> = ({ fade, children, className }) => {
  const scrollableDiv = React.useRef<HTMLDivElement>(null);
  const [scrollClass, setScrollClass, scrollRef] = useStateRef('');

  React.useEffect(() => {
    window.addEventListener('scroll', recalcScroll);
    return () => window.removeEventListener('scroll', recalcScroll);
  }, []);

  const recalcScroll = () => {
    const el = scrollableDiv.current;
    if (!el) {
      return;
    }

    const tmpScrollClass = el.getBoundingClientRect().bottom > window.innerHeight ? 'has-scroll-screen' : '';
    if (tmpScrollClass !== scrollRef.current) {
      setScrollClass(tmpScrollClass);
    }
  };

  React.useEffect(recalcScroll);

  return (
    <div ref={scrollableDiv} className={`${className || ''} ${scrollClass} ${fade ? 'has-fade' : ''}`}>
      {children}
      <span
        className='more-scroll-arrow'
        onClick={() =>
          scrollableDiv.current &&
          window.scrollTo({
            top: scrollableDiv.current.getBoundingClientRect().bottom,
          })
        }
      >
        <FontAwesomeIcon icon={faAngleDoubleDown} />
      </span>
    </div>
  );
};
